"use client";

import React from "react";
import { Shield, CheckCircle, Lock, Key, FileKey, ChevronDown } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function FragorSvarOmApiSakerhet() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const faqItems = [{
    question: "Hur hanteras mina kunders personuppgifter?",
    answer: "Vi följer strikta GDPR-protokoll. All kunddata krypteras med AES-256 vid vila och under transport via TLS 1.3. Vi agerar som personuppgiftsbiträde och säljer aldrig information vidare till tredje part.",
    icon: Shield
  }, {
    question: "Vem äger datan som genereras i plattformen?",
    answer: "Du äger alltid din egen data. Vi tillhandahåller verktygen för analys och optimering, men du kan när som helst exportera all historik eller begära permanent radering av information från våra servrar.",
    icon: FileKey
  }];
  return <section data-section-id="3790" id="policydetaljer" className="bg-background text-foreground relative overflow-hidden py-24 px-4 sm:px-6 lg:px-8">
      {}
      <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(ellipse_at_center,_var(--primary)_0%,_transparent_60%)] opacity-5 blur-3xl" />
      
      <div ref={ref} className={cn("relative z-10 mx-auto max-w-3xl transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <div className="flex flex-col items-center text-center mb-12 space-y-6">
          <Badge variant="outline" className="bg-primary/5 text-primary border-primary/20 px-4 py-1.5 text-sm backdrop-blur-sm shadow-sm">
            <Shield className="w-3.5 h-3.5 mr-2 fill-primary/10" />
            Säkerhet & Integritet
          </Badge>
          
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold tracking-tight text-foreground">
            Policy-detaljer för Operatörer
          </h2>
          
          <p className="text-muted-foreground max-w-xl text-lg leading-relaxed">
            Vi värnar om din verksamhets data. Här förklarar vi hur vi skyddar din integritet och hanterar information med branschledande säkerhetsstandarder.
          </p>
        </div>

        <div className="bg-secondary border border-muted rounded-[3px] p-6 md:p-8 shadow-sm ring-1 ring-border/5">
          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqItems.map((item, i) => <AccordionItem key={i} value={`item-${i}`} className="border border-muted bg-background/50 rounded-[3px] px-1 data-[state=open]:bg-accent/20 data-[state=open]:border-primary/30 transition-all duration-300 overflow-hidden hover:shadow-md" data-index={i}>
                <AccordionTrigger className="hover:no-underline py-5 px-4 text-left group">
                  <div className="flex items-center gap-4 w-full">
                    <div className="flex items-center justify-center w-10 h-10 rounded-full bg-primary/10 text-primary shrink-0 group-hover:bg-primary/20 transition-colors duration-300">
                      <item.icon className="w-5 h-5" />
                    </div>
                    <span className="text-base md:text-lg font-medium text-foreground group-hover:text-primary transition-colors">
                      {item.question}
                    </span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground pl-[4.5rem] pr-6 pb-6 text-base leading-relaxed">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>

        <div className="mt-12 text-center">
          <p className="text-sm text-muted-foreground">
            Har du specifika frågor om våra avtal eller dataskydd?{" "}
            <Link to="#" className="text-primary hover:text-primary/80 hover:underline underline-offset-4 font-medium transition-colors">
              Kontakta vårt juridiska team
            </Link>
          </p>
        </div>
      </div>
    </section>;
}